import React from 'react'
import styled from 'styled-components'
import BodyText from '../Typography/BodyText'
import clsx from 'clsx'
import { rem } from 'polished'
import LineCheckIcon from '../Icons/line/LineCheckIcon'

/**
 * Preserves the 32px box container.
 */
const Wrapper = styled.div`
  display: grid;
  place-items: center;
  height: ${rem(32)};
  width: ${rem(32)};
`

const Container = styled.div`
  display: grid;
  place-items: center;
  height: ${rem(24)};
  width: ${rem(24)};
  padding: ${rem(2)};
  outline: ${rem(1)} solid transparent;
  outline-offset: ${rem(2)};
  border-radius: ${props => props.theme.borderRadius.round};
  transition: outline-color 200ms, background-color 200ms, color 200ms;

  &.state-active {
    color: ${props => props.theme.palette.neutral.default.eight};
    background-color: ${props => props.theme.palette.brand.primary.normal};
    outline-color: ${props => props.theme.palette.brand.primary.normal};
  }
  &.state-inactive {
    color: ${props => props.theme.palette.neutral.default.one};
    background-color: ${props => props.theme.palette.neutral.default.five};
  }
  &.state-completed {
    color: ${props => props.theme.palette.neutral.default.eight};
    background-color: ${props => props.theme.palette.brand.primary.normal};
  }
`

interface Props {
  number: number
  state: 'active' | 'inactive' | 'completed'
}

function _StepIcon(props: Props) {
  const { number, state } = props

  return <Wrapper>
    <Container className={clsx(`state-${state}`)}>
      {state !== 'completed' && <BodyText variant="medium">{number}</BodyText>}
      {state === 'completed' && <LineCheckIcon size="S" />}
    </Container>
  </Wrapper>
}

export default _StepIcon
